export const defaultHelpCenterConfig = {
    tabs: [
        {
            id: "recommendations",
            label: "Your recommendations",
            title: "",
            tiletype: "grid",
            tiles: [],
        },
    ],
    links: [],
};
